import React,{useState, useEffect}  from 'react';
import Card from 'react-bootstrap/Card';
import Sides from '../Bars/Csharpsidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Cspassarg(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>
      <Sides/>
      <Helmet>
 
 <title>C# passing argument tutorial For Beginners</title>
 <meta name="description" content="C# passing argument tutorial for beginners.An argument may be a variable as a constant value that is used in the () of function. CodeExampler provides Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners" />
 <meta name="keywords" content="codeexampler,programming language,tutorial for begineers,C# passing argument,C# passing argument C# tutorial for begineers" />
 <link rel="canonical" href="https://www.codeexampler.com/csharp-passing-argument" />
 </Helmet>

 <div className='lg:pl-56'>
    <h1 className="m-4 mh1">Passing argument in C#</h1>
    <div className="first">
        <a href="/csharp-user-define-function">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/csharp-object-initializers">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    <p className="mt-4 para ">An argument may be a variable as a Constant value that is used in the () of function.</p>



<h2 className="headings">Q-Example of the Passing Argument in C#?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-7">public </span>
            <span className="qwerty-4">class </span>
            <span className="qwerty-">a</span>
            {"\n"}
            <span className="qwerty-3"> &#123;</span>
            {"\n"}
            <span className="qwerty-7">public </span>
          <span className="qwerty">static </span>
          <span className="qwerty-3">void </span>
          <span className="qwerty-4">argument </span>
          <span className="qwerty-1">(</span>
          <span className="qwerty-10">int </span>
          <span className="qwerty-6">a</span>
          <span className="qwerty-1">) </span>
          <span className="qwerty-4">// </span>
          <span className="qwerty-5">int n is a formal argument</span>  
          {"\n"}
            <span className="qwerty-3"> &#123;</span>
            {"\n"}
            <span className="qwerty-6"> Console.</span>
            <span className="qwerty-5">WriteLine</span>
            <span className="qwerty-7"> (</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-10">my no is</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-4"> +</span>
            <span className="qwerty-6"> a</span>
            <span className="qwerty-7">)</span>
            <span className="qwerty-5">;</span>
            {"\n"}
            <span className="qwerty-3"> &#125;</span>
            {"\n"}
            <span className="qwerty-7">public </span>
          <span className="qwerty">static </span>
          <span className="qwerty-3">void </span>
          <span className="qwerty-4">main </span>
          <span className="qwerty-7">(</span>
          <span className="qwerty-10">String </span>
          <span className="qwerty-1">[] </span>
          <span className="qwerty-3">args</span>
          <span className="qwerty-7">) </span>
          {"\n"}
            <span className="qwerty-3"> &#123;</span>
            {"\n"}
            <span className="qwerty-6"> Console.</span>
            <span className="qwerty-5">WriteLine</span>
            <span className="qwerty-7"> (</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-10">enter</span>
            <span className="qwerty-6"> a </span>
            <span className="qwerty-10">number</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-7">)</span>
            <span className="qwerty-5">;</span>
            {"\n"}
            <span className="qwerty-5">  n </span>
            <span className="qwerty-7">= </span>
            <span className="qwerty-3">Convert.</span>
            <span className="qwerty-1">ToInt32</span>
            <span className="qwerty-7">(</span>
            <span className="qwerty-6">Console.</span>
            <span className="qwerty-3">ReadLine</span>
            <span className="qwerty-1">()</span>
            <span className="qwerty-7">)</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-4">argument </span>
          <span className="qwerty-1">(</span>
          <span className="qwerty-6">a</span>
          <span className="qwerty-1">)</span>
          <span className="qwerty-3">; </span>
          <span className="qwerty-4">//</span>
          <span className="qwerty-5"> n is a actual argument</span>  
          {"\n"} 
            <span className="qwerty-4"> &#125;</span>
            {"\n"}
            <span className="qwerty-4"> &#125;</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

      <h2 className="headings">Output</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-2"> 20</span>
            {"\n"}{"\n"}
            <span className="qwerty-7"> Answer</span>
            {"\n"}{"\n"}
            <span className="qwerty-5"> my no is</span>
            <span className="qwerty-2"> 20</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>



<h2 className="headings">Q-Write a program to check a no is even or odd by using passing argument?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-7">public </span>
            <span className="qwerty-4">class </span>
            <span className="qwerty">a</span>
            {"\n"}
            <span className="qwerty-3"> &#123;</span>
            {"\n"}
            <span className="qwerty-7">public </span>
            <span className="qwerty">static </span>
            <span className="qwerty-3">void </span>
            <span className="qwerty-4">argument </span>
            <span className="qwerty-1">(</span>
            <span className="qwerty-10">int </span>
            <span className="qwerty-6">a</span>
            <span className="qwerty-1">) </span>
            <span className="qwerty-4">// </span>
            <span className="qwerty-5">int n is a formal argument</span>
            {"\n"}
            <span className="qwerty-3"> &#123;</span>
            {"\n"}
            <span className="qwerty">if </span>
            <span className="qwerty-1">(</span>
            <span className="qwerty-4">i </span>
            <span className="qwerty-8">% </span>
            <span className="qwerty-6">2 </span>
            <span className="qwerty-8">== </span>
            <span className="qwerty-6">0</span>
            <span className="qwerty-1">)</span>
            {"\n"}
            <span className="qwerty-3"> &#123;</span>
            {"\n"}
            <span className="qwerty-6"> Console.</span>
            <span className="qwerty-5">WriteLine</span>
            <span className="qwerty-7"> (</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-10">even no</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-7">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-3"> &#125;</span>
            {"\n"}
            <span className="qwerty-5">else</span>
            {"\n"}
            <span className="qwerty-3"> &#123;</span>
            {"\n"}
            <span className="qwerty-6"> Console.</span>
            <span className="qwerty-5">WriteLine</span>
            <span className="qwerty-7"> (</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-10">odd no</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-7">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-3"> &#125;</span>
            {"\n"}
            <span className="qwerty-3"> &#125;</span>
            {"\n"}
            <span className="qwerty-7">public </span>
            <span className="qwerty">static </span>
            <span className="qwerty-3">void </span>
            <span className="qwerty-4">main </span>
            <span className="qwerty-7">(</span>
            <span className="qwerty-10">String </span>
            <span className="qwerty-1">[] </span>
            <span className="qwerty-3">args</span>
            <span className="qwerty-7">) </span>
            {"\n"}
            <span className="qwerty-3"> &#123;</span>
            {"\n"}
            <span className="qwerty-6"> Console.</span>
            <span className="qwerty-5">WriteLine</span>
            <span className="qwerty-7"> (</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-10">enter</span>
            <span className="qwerty-6"> a </span>
            <span className="qwerty-10">number</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-7">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-6"> a </span>
            <span className="qwerty-7">= </span>
            <span className="qwerty-3">Convert.</span>
            <span className="qwerty-1">ToInt32</span>
            <span className="qwerty-7"> (</span>
            <span className="qwerty-6">Console.</span>
            <span className="qwerty-3">ReadLine</span>
            <span className="qwerty-1"> ()</span>
            <span className="qwerty-7">)</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-7"> check </span>
            <span className="qwerty-1">(</span>
            <span className="qwerty-6">a</span>
            <span className="qwerty-1">)</span>
            <span className="qwerty-3">;</span>
            <span className="qwerty-4"> //</span>
            <span className="qwerty-5"> a is a actual argument</span>
            {"\n"}
            <span className="qwerty-4"> &#125;</span>
            {"\n"}
            <span className="qwerty-4"> &#125;</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

      <h2 className="headings">Output</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-2"> 40</span>
            {"\n"}{"\n"}
            <span className="qwerty-7"> Answer</span>
            {"\n"}{"\n"}
            <span className="qwerty-10"> even no</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>




<h2 className="headings">Q-Write a program check greater no by using a function in C#?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-7">public </span>
            <span className="qwerty-4">class </span>
            <span className="qwerty">a</span>
            {"\n"}
            <span className="qwerty-3"> &#123;</span>
            {"\n"}
            <span className="qwerty-7">public </span>
            <span className="qwerty">static </span>
            <span className="qwerty-3">void </span>
            <span className="qwerty-4">maximum </span>
            <span className="qwerty-1">(</span>
            <span className="qwerty-10">int </span>
            <span className="qwerty">a</span>
            <span className="qwerty-8"> , </span>
            <span className="qwerty-10">int </span>
            <span className="qwerty">b</span>
            <span className="qwerty-1">) </span>
            {"\n"}
            <span className="qwerty-3"> &#123;</span>
            {"\n"}
            <span className="qwerty-4">if </span>
            <span className="qwerty-1">(</span>
            <span className="qwerty">a</span>
            <span className="qwerty-8"> &#62; </span>
            <span className="qwerty">b</span>
            <span className="qwerty-1">)</span>
            {"\n"}
            <span className="qwerty-3"> &#123;</span>
            {"\n"}
            <span className="qwerty-1"> Console.</span>
            <span className="qwerty-5">WriteLine</span>
            <span className="qwerty-7"> (</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-4">maximum</span>
            <span className="qwerty-1"> = </span>
            <span className="qwerty-4">"</span>
            <span className="qwerty-8">+</span>
            <span className="qwerty">a</span>
            <span className="qwerty-1">)</span>
            <span className="qwerty-1">;</span>
            {"\n"}
            <span className="qwerty-3"> &#125;</span>
            {"\n"}
            <span className="qwerty-5">else</span>
            {"\n"}
            <span className="qwerty-3"> &#123;</span>
            {"\n"}
            <span className="qwerty-1"> Console.</span>
            <span className="qwerty-5">WriteLine</span>
            <span className="qwerty-7"> (</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-4">maximum</span>
            <span className="qwerty-1"> = </span>
            <span className="qwerty-4">"</span>
            <span className="qwerty-8">+</span>
            <span className="qwerty">b</span>
            <span className="qwerty-1">)</span>
            <span className="qwerty-1">;</span>
            {"\n"}
            <span className="qwerty-3"> &#125;</span>
            {"\n"}
            <span className="qwerty-3"> &#125;</span>
            {"\n"}
            <span className="qwerty-7">public </span>
            <span className="qwerty">static </span>
            <span className="qwerty-3">void </span>
            <span className="qwerty-4">main </span>
            <span className="qwerty-7">(</span>
            <span className="qwerty-10">String </span>
            <span className="qwerty-1">[] </span>
            <span className="qwerty-3">args</span>
            <span className="qwerty-7">) </span>
            {"\n"}
            <span className="qwerty-3"> &#123;</span>
            {"\n"}
            <span className="qwerty-1"> Console.</span>
            <span className="qwerty-5">WriteLine</span>
            <span className="qwerty-7"> (</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-10">enter</span>
            <span className="qwerty-6"> x </span>
            <span className="qwerty-10">and </span>
            <span className="qwerty-6">y </span>
            <span className="qwerty-10">numbers</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-7">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-6"> x </span>
            <span className="qwerty-7">= </span>
            <span className="qwerty-3">Convert.</span>
            <span className="qwerty-1">ToInt32</span>
            <span className="qwerty-7"> (</span>
            <span className="qwerty-1">Console.</span>
            <span className="qwerty-3">ReadLine</span>
            <span className="qwerty-1"> ()</span>
            <span className="qwerty-7">)</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-6"> y </span>
            <span className="qwerty-7">= </span>
            <span className="qwerty-3">Convert.</span>
            <span className="qwerty-1">ToInt32</span>
            <span className="qwerty-7"> (</span>
            <span className="qwerty-1">Console.</span>
            <span className="qwerty-3">ReadLine</span>
            <span className="qwerty-1"> ()</span>
            <span className="qwerty-7">)</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-4">maximum</span>
            <span className="qwerty-1">(</span>
            <span className="qwerty-4">x</span>
            <span className="qwerty-8"> , </span>
            <span className="qwerty-4">y</span>
            <span className="qwerty-1">); </span>
            {"\n"}
            <span className="qwerty-3"> &#125;</span>
            {"\n"}
            <span className="qwerty-3"> &#125;</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

      <h2 className="headings">Output</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-6"> 40</span>
            {"\n"}
            <span className="qwerty-6"> 65</span>
            {"\n"}{"\n"}
            <span className="qwerty-7"> Answer</span>
            {"\n"}{"\n"}
            <span className="qwerty-10"> maximum </span>
            <span className="qwerty-1">=</span>
            <span className="qwerty-6"> 65 </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

  <h1 className="mt-5">  </h1>
       
  <div className="back">
        <a href="/csharp-user-define-function">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/csharp-object-initializers">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
        </div>
    </div>
)

}
export default Cspassarg;